<template>
  <div class="pepper-celebration">
    <div class="body">
      <div class="header">
        <img class="riseup-pepper-logo" :src="require('@/assets/onboarding/pepperLogo.svg')"/>
      </div>
      <div :class="{ title: true, fadeIn1: shouldFadeIn }">
        <slot name="information-title">{{ firstName }},<br>השירות פתוח ללקוחות פפר ואיזה כיף לראות אותך שוב!</slot>
      </div>
      <div :class="{ text: true, fadeIn2: shouldFadeIn }">
        אנחנו פה כדי לעזור לך לעשות את
        <span class="bold">הצעד הראשון בדרך לצמיחה כלכלית וחיסכון</span>, ו<span class="bold">הצוות שלנו זמין בשבילך בצ׳אט</span>
        לכל שאלה שצצה.
      </div>
    </div>
    <img v-if="showSun" class="static-sun" :src="require('@/assets/onboarding/yellow-circle.svg')">
  </div>
</template>
<script>

export default {
  props: {
    firstName: { type: String, required: true },
    showSun: { type: Boolean, default: false },
    shouldFadeIn: { type: Boolean, default: true },
  },
  name: 'PepperCelebrationInternal',
};
</script>

<style lang="scss">
  @import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }

  .pepper-celebration {
    height: 100%;
    width: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    .body {
      flex-grow: 1;
      padding: 50px 30px 0;
      justify-content: flex-start;
      color: white;

      .header img {
        max-width: 100%;
      }

      .title {
        margin-top: 18px;
        padding: 10px 0px;
        font-size: 24px;
        font-weight: bold;
        line-height: 34px;
        white-space: pre-line;
      }

      .text {
        padding: 16px 0px;
        font-size: 17px;
        line-height: 30px;
        flex-grow: 1;

        p:first-child {
          margin-bottom: 20px;
        }
      }

      .fadeIn1 {
        animation: fadeIn 1s;
      }

      .fadeIn2 {
        animation: fadeIn 2s;
      }

      .bold {
        font-weight: bold;
      }

      .static-sun {
        width: 100%;
      }
    }
  }
</style>
